import { render, staticRenderFns } from "./oneClickArchive.vue?vue&type=template&id=7f2fe054&scoped=true"
import script from "./oneClickArchive.vue?vue&type=script&lang=js"
export * from "./oneClickArchive.vue?vue&type=script&lang=js"
import style0 from "./oneClickArchive.vue?vue&type=style&index=0&id=7f2fe054&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2fe054",
  null
  
)

export default component.exports